/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconObservationOutline = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-observation-outline',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("path", { d: "M9.6 14.703a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0Zm0 0v-7.2c0-.662-.806-1.2-1.8-1.2-.995 0-1.478.444-1.705.816l-3.408 6.16M14.4 14.703a3.6 3.6 0 1 0 7.2 0 3.6 3.6 0 0 0-7.2 0Zm0 0v-7.2c0-.662.806-1.2 1.8-1.2.995 0 1.478.444 1.705.816l3.408 6.16m-4.098-6.772-.875-1.513c-.192-.297-1.267-.243-1.34.11l-.212 1.655m-8.003-.252.875-1.513c.192-.299 1.267-.244 1.34.11l.212 1.655M9.6 9.903h4.8v2.4H9.6v-2.4Z", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })));
});
IconObservationOutline.displayName = 'IconObservationOutline';
export default IconObservationOutline;
